import comp from "./MoreFilters";
export default comp;
